import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamApi } from '../api';
import { TEAM_DETAIL_QUERY_KEY, TEAM_TASKS_QUERY_KEY } from '../queries';

interface DeleteTeamBoardParams {
  teamId: string;
  boardId: string;
}

export const useDeleteTeamBoard = () => {
  const queryClient = useQueryClient();

  const deleteTeamBoardMutation = useMutation({
    mutationFn: ({ teamId, boardId }: DeleteTeamBoardParams) => {
      return teamApi.archiveTeamBoard(teamId, boardId).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_TASKS_QUERY_KEY });
    },
  });

  return {
    deleteTeamBoard: deleteTeamBoardMutation.mutateAsync,
    isDeletingTeamBoard: deleteTeamBoardMutation.isPending,
    ...deleteTeamBoardMutation,
  };
};
